<template>
  <div>
    <div class="c-tabs">
      <div class="c-tabs__link">
        <h1 class="c-tabs__title">{{ title }}</h1>
        <ul class="tabs">
          <li class="tabs__item" v-for="tab in targetTabs" :key="tab.name" :class="{ 'is-active': tab.isActive }">
            <a :class="[ { link__warning: tab.warningColor }, 'link' ]" @click="selectTab(tab)">
              <p4a-icon class="link__icon" :icon="tab.icon" />
              <span class="link__text">{{ tab.name }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="c-tabs__content">
          <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'wow'
    }
  },
  data () {
    return {
      tabs: []
    }
  },
  created () {
    this.tabs = this.$children
  },
  methods: {
    selectTab (selectedTab) {
      const tabs = this.tabs
      tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })
      // autofocus automatically on the first field with autofocus attribute
      function focusOnFirstInput () {
        const index = tabs.map((e) => { return e.isActive }).indexOf(true) + 1
        let autofocus = document.querySelector(
          '.c-tabs__content>div:nth-child(' + index + ') [autofocus]'
        )
        if (autofocus) {
          autofocus.focus()
        }
      }
      setTimeout(focusOnFirstInput, 500)
    }
  },
  computed: {
    targetTabs () {
      return this.tabs.filter(a => a.name !== undefined)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tabs/tabs.vue